module.exports = __webpack_public_path__ + "img/avid-reader.8ee7743a.svg";